// extracted by mini-css-extract-plugin
module.exports = {"footer-wrapper":"CpzZxCJ-gRuCJ1qtTc6hyQ==","footerWrapper":"CpzZxCJ-gRuCJ1qtTc6hyQ==","quick-div":"rH65HVmiLmJ+-5840Qoefg==","quickDiv":"rH65HVmiLmJ+-5840Qoefg=="};